import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    if (window.location.hash) {
      const matchingTab = this.tabTargets.find(tab => tab.getAttribute("href") === window.location.hash)
      if (matchingTab) {
        this.activate(matchingTab)
        return
      }
    }
    // Default: activate the first tab
    if (this.tabTargets.length > 0) {
      this.activate(this.tabTargets[0])
    }
  }

  show(event) {
    event.preventDefault()
    this.activate(event.currentTarget)
  }

  activate(selectedTab) {
    const targetId = selectedTab.getAttribute("href")?.substring(1)
    if (!targetId) return

    // Update tab styles
    this.tabTargets.forEach(tab => {
      tab.classList.remove("border-[#C4A484]", "text-[#C4A484]")
      tab.classList.add("border-transparent", "text-[#8C8C8C]")
    })
    selectedTab.classList.remove("border-transparent", "text-[#8C8C8C]")
    selectedTab.classList.add("border-[#C4A484]", "text-[#C4A484]")

    // Show/hide panels
    this.panelTargets.forEach(panel => {
      if (panel.id === targetId) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })

    // Update URL hash without scrolling
    history.replaceState(null, "", `#${targetId}`)
  }
}
